<template>
  <ErrorMessageLayout
    image="./triangle-warning.svg"
    title="Internal Server Error"
    errorcode="500"
  >
    Oops! Something went wrong: nobody said 100% reliability.
    <template v-slot:action>
      <el-button @click="tryAgain">Try Again</el-button>
    </template>
  </ErrorMessageLayout>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import ErrorMessageLayout from "@/modules/messages/ErrorMessageLayout.vue";
import { RoutesName } from "@/router";

@Options({
  components: { ErrorMessageLayout },
})
export default class InternalServerError extends Vue {
  tryAgain(): void {
    this.$router.push(RoutesName.SIGNUP);
  }
}
</script>
